import React from "react";
import {
  Datagrid,
  List,
  Loading,
  NumberField,
  DeleteButton,
  EditButton,
  NumberInput,
} from "react-admin";
import { ListActions } from "../Signet/ListActions";

const PreciousInlayPricingFilters = [
  <NumberInput source="quantity" label="Quantity" key="quantity" />,
  <NumberInput source="width" label="Width" key="width" />,
];

const PreciousInlayPricingList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;

  return (
    <List
      {...props}
      exporter={false}
      actions={
        <ListActions filters={PreciousInlayPricingFilters} />
      }
      sort={{ field: "id", order: "ASC" }}
    >
      <Datagrid rowClick={null}>
        <NumberField source="quantity" label="Quantity" />
        <NumberField source="width" label="Width" />
        <NumberField
          source="volume_delta"
          label="Volume Delta"
          sortable={false}
        />
        <NumberField source="labor" label="Labor" sortable={false} />
        <NumberField
          source="silver_markup"
          label="Silver Markup"
          sortable={false}
        />
        <NumberField
          source="10k_markup"
          label="10k Markup"
          sortable={false}
        />
        <NumberField
          source="14k_markup"
          label="14k Markup"
          sortable={false}
        />
        <NumberField
          source="18k_markup"
          label="18k Markup"
          sortable={false}
        />
        <NumberField
          source="platinum_markup"
          label="Platinum Markup"
          sortable={false}
        />
        <NumberField
          source="palladium_markup"
          label="Palladium Markup"
          sortable={false}
        />
        <EditButton />
        <DeleteButton label="" undoable={false} />
      </Datagrid>
    </List>
  );
};

export default PreciousInlayPricingList;
